
import { Injectable, Injector } from '@angular/core';

import { ObjectClass } from '@app/common/enums';

import { FilterConfigService } from './filter-config.service';

@Injectable()
export class ProjectFilterConfigService extends FilterConfigService {

  constructor(
    protected _injector: Injector,
  ) {
    super(_injector);
    this._init();
  }

  private _init(): void {
    this._filters = [
      this.createFilterKeyword(),
      this.createFilterStatus(ObjectClass.Project),
    ];
  }

}
